/** API BusinessUnit ↔ UI BU master fields. */

function resolveVillageCode(row) {
  return row?.village?.code ?? row?.villageCode ?? '';
}

function resolveVillageName(row) {
  return row?.village?.name ?? row?.villageName ?? '';
}

export function businessUnitFromApi(row) {
  if (!row) return null;
  const villageDbId = row.villageId != null ? Number(row.villageId) : null;
  return {
    id: row.id,
    buId: row.code ?? '',
    shortName: row.shortName ?? '',
    fullNameGst: row.fullNameGst ?? '',
    address1: row.address1 ?? '',
    address2: row.address2 ?? '',
    villageId: resolveVillageCode(row),
    villageDbId,
    villageName: resolveVillageName(row),
    active: row.isActive !== false,
    createdAt: row.createdAt ?? null,
    updatedAt: row.updatedAt ?? null,
  };
}

export function businessUnitToApi(ui) {
  if (!ui) return null;
  const villageId = Number(ui.villageDbId ?? ui.villageId);
  return {
    shortName: ui.shortName,
    fullNameGst: ui.fullNameGst || null,
    address1: ui.address1 || null,
    address2: ui.address2 || null,
    villageId: Number.isFinite(villageId) ? villageId : undefined,
    isActive: ui.active !== false,
  };
}

export function siteFromApi(row) {
  if (!row) return null;
  const villageDbId = row.villageId != null ? Number(row.villageId) : null;
  return {
    id: row.id,
    siteId: row.code ?? '',
    buId: row.businessUnit?.code ?? '',
    buDbId: row.buId != null ? Number(row.buId) : null,
    siteName: row.siteName ?? '',
    projectOperation: row.projectOperation ?? '',
    address1: row.address1 ?? '',
    address2: row.address2 ?? '',
    villageId: resolveVillageCode(row),
    villageDbId,
    villageName: resolveVillageName(row),
    pinOverride: row.pinOverride ?? '',
    active: row.isActive !== false,
    createdAt: row.createdAt ?? null,
    updatedAt: row.updatedAt ?? null,
  };
}

export function siteToApi(ui) {
  if (!ui) return null;
  const buId = Number(ui.buDbId ?? ui.buId);
  const villageId = Number(ui.villageDbId ?? ui.villageId);
  return {
    buId: Number.isFinite(buId) ? buId : undefined,
    siteName: ui.siteName,
    projectOperation: ui.projectOperation || null,
    address1: ui.address1 || null,
    address2: ui.address2 || null,
    villageId: Number.isFinite(villageId) ? villageId : undefined,
    pinOverride: ui.pinOverride || null,
    isActive: ui.active !== false,
  };
}
